import { Action, createReducer, on } from '@ngrx/store';
import { EMeetingStateStatus, IMeetingState } from '../models/meeting.model';

import {
  addAProduct,
  addAProductError,
  addAProductSuccess,
  deleteAProduct,
  deleteAProductError,
  deleteAProductSuccess,
  updateAProduct,
  updateAProductError,
  updateAProductSuccess,
  updateMeeting,
  updateMeetingError,
  updateMeetingSuccess,
  viewMeeting,
  viewMeetingError,
  viewMeetingSuccess,
} from '../actions/meeting.action';

const initalState: IMeetingState = {
  status: EMeetingStateStatus.INITIALIZING,
  state: null,
  data: null,
};

const meetingReducer = createReducer(
  initalState,

  on(viewMeeting, (state, { id_meeting }) => {
    return {
      ...state,
      state: EMeetingStateStatus.LOADING,
      current_meeting_id: id_meeting,
      // prev_message_id,
      // next_message_id
    };
  }),
  on(viewMeetingSuccess, (state, { data }) => {
    return {
      ...state,
      data,
      status: EMeetingStateStatus.READY,
    };
  }),
  on(viewMeetingError, (state, { error }) => {
    return {
      ...state,
      status: EMeetingStateStatus.ERROR,
      error,
    };
  }),

  on(updateMeeting, (state, { meeting }) => {
    return {
      ...state,
      state: EMeetingStateStatus.UPDATING,
      current_meeting_id: meeting.meeting_id,
    };
  }),
  on(updateMeetingSuccess, (state, { response }) => {
    return {
      ...state,
      data: response,
      status: EMeetingStateStatus.UPDATED,
    };
  }),
  on(updateMeetingError, (state, { error }) => {
    return {
      ...state,
      status: EMeetingStateStatus.ERROR,
      error,
    };
  }),

  on(addAProduct, (state, { meeting, product }) => {
    return {
      ...state,
      state: EMeetingStateStatus.ADDED_PROD,
      status: EMeetingStateStatus.UPDATING,
      // prev_message_id,
      // next_message_id
    };
  }),
  on(addAProductSuccess, (state, { response }) => {
    return {
      ...state,
      data: response,
      status: EMeetingStateStatus.READY_S,
    };
  }),
  on(addAProductError, (state, { error }) => {
    return {
      ...state,
      status: EMeetingStateStatus.ERROR,
      error,
    };
  }),
  on(updateAProduct, (state, { meeting, product }) => {
    return {
      ...state,
      state: EMeetingStateStatus.UPDATED_PROD,
      status: EMeetingStateStatus.UPDATING,
      // prev_message_id,
      // next_message_id
    };
  }),
  on(updateAProductSuccess, (state) => {
    return {
      ...state,
      status: EMeetingStateStatus.UPDATED,
    };
  }),
  on(updateAProductError, (state, { error }) => {
    return {
      ...state,
      state: EMeetingStateStatus.ERROR,
      status: EMeetingStateStatus.READY,
      error,
    };
  }),
  on(deleteAProduct, (state, { meeting, product }) => {
    return {
      ...state,
      state: EMeetingStateStatus.DELETED_PROD,
      status: EMeetingStateStatus.UPDATING,
      // prev_message_id,
      // next_message_id
    };
  }),
  on(deleteAProductSuccess, (state, { response }) => {
    return {
      ...state,
      data: response,
      status: EMeetingStateStatus.READY_S,
    };
  }),
  on(deleteAProductError, (state, { error }) => {
    return {
      ...state,
      status: EMeetingStateStatus.ERROR,
      error,
    };
  }),
);

export function reducer(state: IMeetingState, action: Action) {
  return meetingReducer(state, action);
}
